import Card from 'components/Card'
import styled from 'styled-components'

export const PaginationContainer = styled.div`
    margin-top: 40px;
    width: 100%;
`
export const StyledCard = styled(Card)`
    padding: 0px;
`
